import React, { useState, useEffect, useReducer, useCallback } from 'react'
import { Flex } from 'reflexbox/styled-components'
import { toast } from 'react-toastify'
import { useHistory, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import Loader from 'components/Loader'
import Button from 'components/Button'
import Card from 'components/Card'
import { NumberField, TextField } from 'components/Form/Fields'

import { reducer as loadingReducer } from 'helpers/loadingReducer'
import { getPartner, addPackageSpecialPrice } from 'services/partners'

const PartnerPriceEdit = () => {
  const [partner, setPartner] = useState({})
  const [currentPrice, setCurrentPrice] = useState(null)
  const [requestStatus, dispatch] = useReducer(loadingReducer, { isLoading: true, error: false })

  const { id, package_id } = useParams()
  const history = useHistory()

  const handleSubmit = useCallback(
    async ({ package_price }) => {
      try {
        await addPackageSpecialPrice(id, {
          package_id,
          value: package_price,
        })

        toast.success(`Preço do pacote ${currentPrice.package_name} atualizado com sucesso`)

        history.goBack()
      } catch (e) {
        console.log(e)
        toast.error('Não foi possível atualizar o preço do pacote')
      }
    },
    [currentPrice],
  )

  useEffect(() => {
    const fetchPartner = async () => {
      try {
        const {
          data: { prices, ...data },
        } = await getPartner(id)

        const currentPrice = prices.find(price => price.package_id == package_id)

        setPartner(data)
        setCurrentPrice(currentPrice)
        dispatch({ type: 'success' })
      } catch (e) {
        console.log(e)
        toast.error('Não foi possível carregar os dados do Parceiro.')
        dispatch({ type: 'error' })
      }
    }

    fetchPartner()
  }, [])

  return (
    <Flex width={1} flexDirection='column'>
      <Flex width={1} justifyContent='space-between' alignItems='center'>
        {requestStatus.isLoading ? <Loader /> : <h1>{partner?.company_name}</h1>}
      </Flex>

      {requestStatus.isLoading ? (
        <Flex justifyContent='center' alignItems='center' height='200px'>
          <Loader />
        </Flex>
      ) : (
        <Card mt={24}>
          <Formik
            initialValues={{ package_name: currentPrice.package_name, package_price: currentPrice.package_price }}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Flex flexDirection='column' width={[1, '280px']}>
                  <TextField mb='24px' name='package_name' label='Pacote' disabled />
                  <NumberField
                    mb='24px'
                    name='package_price'
                    label='Preço Atual'
                    placeholder='R$ 10,00'
                    prefix='R$ '
                    decimalScale={2}
                  />
                </Flex>
                <Flex width={[1, '584px']} justifyContent='space-between'>
                  <Button size='big' onClick={() => history.goBack()} type='button' outlined>
                    Voltar
                  </Button>
                  <Button size='big' type='submit' disabled={isSubmitting}>
                    {isSubmitting ? <Loader /> : 'Salvar'}
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </Card>
      )}
    </Flex>
  )
}

export default PartnerPriceEdit
